import { createApp } from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import 'leaflet/dist/leaflet.css'
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/service-worker.js')
}
createApp(App).mount('#app')
